import { FC } from 'react'
import { Input, Form } from 'antd'
import { useTranslation } from 'react-i18next'
import style from './style.m.less'
import {userTypeIdPicker} from "../../../helpers";
import {EUserType} from "../../../../constants/approval";

interface IThreePartsBlock {
    labels: string[]
    required: boolean
    needCheckInnByAttorney: boolean
    attorneyCompanyInn?: string
}

const ThreePartsBlock: FC<IThreePartsBlock> = ({ labels, required, needCheckInnByAttorney, attorneyCompanyInn }) => {
    const { t } = useTranslation()

    return (
        <div className={style.inputsWrapperShort}>
            <div>
                <div className={style.inputBlock}>
                    {labels[0]}
                    {required && <div className={style.star}>*</div>}
                </div>
                <Form.Item
                    name={'company_inn'}
                    rules={[
                        {
                            required: required,
                            pattern: new RegExp(/^\d+$/),
                            message: t('login.pleaseINN'),
                        },
                        {
                            validator: async (_, value) => {
                                if (needCheckInnByAttorney && value !== attorneyCompanyInn) {
                                    throw new Error(t('editMyProfile.attorney.errCompanyInn'));
                                }
                            }
                        }
                    ]}
                >
                    <Input className={style.inputMiddle} minLength={10} maxLength={10} />
                </Form.Item>
            </div>
            <div>
                <div className={style.inputBlock}>
                    {labels[2]}
                    {required && <div className={style.star}>*</div>}
                </div>
                <Form.Item
                    name="kpp"
                    rules={[
                        {
                            required: required,
                            pattern: new RegExp(/^\d+$/),
                            message: t('login.pleaseKPP'),
                        },
                    ]}
                >
                    <Input className={style.inputMiddle} minLength={9} maxLength={9} />
                </Form.Item>
            </div>
            <div>
                <div className={style.inputBlock}>
                    {labels[1]}
                    {required && <div className={style.star}>*</div>}
                </div>
                <Form.Item
                    name="ogrn"
                    rules={[
                        {
                            required: required,
                            pattern: new RegExp(/^\d+$/),
                            message: t('login.pleaseOGRN'),
                        },
                    ]}
                >
                    <Input className={style.inputMiddle} minLength={13} maxLength={13} />
                </Form.Item>
            </div>
        </div>
    )
}

export default ThreePartsBlock
